<template>
    <div>
        <b-dropdown v-model="selected" block variant="link" toggle-class="text-decoration-none"
                    class="modal-select-costtype" :text="selectionName" no-caret>
            <template #button-content>
                <span v-if="selected" class="float-left text-class">{{selected.name}}</span>
            </template>
            <b-dropdown-item v-for="costType in costTypeList" :key="costType.id" @click="select(costType)">
                <div class="item-wrap">
                    <span class="emoji" v-html="get_icon(costType.icon)"></span>&nbsp;
                    <span class="item-text">{{costType.name}}</span>
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>
<script>
    import CostTypeService from "@/store/services/costtype.service.js";

    export default {
        name: "CostTypeSelector",
        props: {
            value: Number,
        },
        watch: {
            value: function (newVal, oldVal) {
                if(newVal !== oldVal && this.costTypeList && this.costTypeList.length>0){
                    this.selected = this.costTypeList.filter(function (d) {
                            return d.id === newVal;
                        })[0];
                }
            }
        },
        components: {},
        data() {
            return {
                selected: {
                    name: "",
                },
                costTypeList: [],
            }
        },
        created(){
            this.getUserList();
        },
        methods: {
            select(option) {
                this.selected = option;
                this.$emit('input', option.id);
                this.$emit('change', option);
            },
            get_icon(icon) {
                if (icon) {
                    return "&#x" + icon + ";";
                }
                return '';
            },
            getUserList(){
                var vm = this;
                CostTypeService.list({company: window.company_id, archived: 'False'}).then(function (response) {
                    vm.costTypeList = response.data;
                    vm.costTypeList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                    vm.costTypeList.unshift({
                        archived: false,
                        company: window.company_id,
                        group: null,
                        id: null,
                        is_default: true,
                        name: vm.$gettext("Nothing selected"),
                        vat_deductible: true
                    });
                    vm.selected = vm.costTypeList[0];
                    if (vm.value) {
                        vm.selected = vm.costTypeList.filter(function (d) {
                            return d.id === vm.value;
                        })[0];
                        vm.$emit('change', vm.selected);
                    }
                });
            },
        },
        computed:{
            selectionName(){
                if(this.selected){
                    return this.selected.name;
                }
                return "";
            }
        }
    };
</script>
<style lang="scss">
.modal-select-costtype {
    button {
        background: $inputBackgroundColor url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 15px center/8px;
        height: 38px;
        border: 0px;
        border-radius: $radiusSm;
        color: #495057 !important;
        box-shadow: $inputBoxShadow;
        &:placeholder { color: $inputPlaceholderColor; opacity: 1; }
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    }
    ul{
        max-height: 450px;
        max-width: 250px;
        overflow: hidden scroll;
        li {
            .dropdown-item {
                font-size: 14px;
                padding: 0.25rem;
                .item-wrap {
                    display: flex;
                    align-items: center;
                    .emoji { 
                        margin-right: 10px;
                        width: 15px;
                        text-align: center;
                    }
                    .item-text {
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
    }
}
@media (max-width: 991px) {
    .modal-select-costtype {
        ul{
            max-width: 100%;
        }
    }
}
</style>
<style scoped>
.text-class{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: unset;
    display: block;
    max-width: 100%;
}
</style>